import { useGranite } from "@/redux/modules/value/translations/translations.provider";

const NoColorsFound = () => {
    const { t } = useGranite();
    return <p>{t("paintConfigurator.noColorsFound")}</p>;
};

export { NoColorsFound };
